/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, December 29th 2021, 11:34:22 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useNavigate } from "react-router-dom";
// import { Tooltip } from "@mui/material";
// import { Settings } from "react-feather";
import { DataTable, HeadCell } from "ui-widgets";
import { ProcessDefinition } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import { useGlobalScope } from "core/providers";
import { resolveURLName } from "core/routes/utils";
import { EmptyServicesCTA } from "./EmptyServicesCTA";
import { ServiceCard } from "./ServiceCard";

// eslint-disable-next-line
const headCells: HeadCell<ProcessDefinition>[] = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "Service Name",
  },
  {
    id: "service_code",
    numeric: false,
    disablePadding: false,
    label: "Service Code",
  },
  {
    id: "site_name",
    numeric: false,
    disablePadding: false,
    label: "Site",
  },
  {
    id: "category_name",
    numeric: false,
    disablePadding: false,
    label: "Category",
  },
  {
    id: "department_name",
    numeric: false,
    disablePadding: false,
    label: "Department",
  },
  {
    id: "source_pre_built_template_name",
    numeric: false,
    disablePadding: false,
    label: "PreBuilt Template",
  },
];

export const ProcessDefinitionList = () => {
  const { globalState } = useGlobalScope();
  const navigate = useNavigate();

  return (
    <DataTable<ProcessDefinition>
      title={`${globalState.selectedOrganization?.name ?? ""} Services`}
      // headCells={headCells}
      defaultOrderBy="title"
      initialRowsPerPage={10}
      dataSource={APISERVICEPATHS.processDefinitions}
      uniqueKey="id"
      noDataMessage={<EmptyServicesCTA organizationName={globalState.selectedOrganization?.name} />}
      unit="Service"
      titleKey="title"
      searchKeys={["title"]} // Currently not used but We can use these in future to allow user to select a field to filter by.
      // renderItemAvatar={(processDefiniton) => (
      //   <OSAvatar name={processDefiniton.title} imageSrc={processDefiniton.service_logo} />
      // )}
      renderGridItem={(processDefinition) => (
        <ServiceCard
          processDefinition={processDefinition}
          onClick={() => navigate(resolveURLName("serviceBuilderRoot", { serviceId: processDefinition.id }))}
        />
      )}
      // renderRowActions={(processDefinition) => (
      //   <Tooltip
      //     title={`Configure this service`}
      //     onClick={() => navigate(resolveURLName("serviceBuilderRoot", { serviceId: processDefinition.id }))}
      //   >
      //     <Settings size="18" />
      //   </Tooltip>
      // )}
      listViewMode="grid"
    />
  );
};
